import { Client } from "../../../../../axios";
import { deepClone } from "../../../../shared/common";
const LIMIT = 20;
const PAGE = 1;

export const getRequisitionMapping = async (params) => {
  const deepParams = deepClone(params);
  const { page, limit = 50, filters } = deepParams;
  delete deepParams.filters;

  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/creative-type`, {
    params: { ...deepParams, ...filters, limit: params.limit || 50 },
  });

  return {
    data: data,
    params: page,
    totalPages: limit != "none" ? Math.ceil(paginate.totalCount / limit) : 1,
  };
};

export const getRequirementType = async ({ name, page }) => {
  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/requirement-type`, {
    params: { limit: LIMIT, page: page || PAGE, search: name || "" },
  });

  return {
    data,
    page: page || PAGE,
    totalPages: !!name ? 1 : Math.ceil(paginate.totalCount / LIMIT),
  };
};

export const getSubmissionType = async ({ name, requirementId, page }) => {
  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/submission-type`, {
    params: {
      limit: LIMIT,
      page: page || PAGE,
      requirementTypeId: requirementId,
      search: name || "",
    },
  });
  return {
    data,
    page: page || PAGE,
    totalPages: !!name ? 1 : Math.ceil(paginate.totalCount / LIMIT),
  };
};

export const getCreativeType = async ({
  name,
  requirementType,
  submissionType,
  page,
}) => {
  const {
    data: { data, paginate },
  } = await Client.get(`uudesr/design-requisition/creative-type`, {
    params: {
      limit: LIMIT,
      page: page || PAGE,
      requirementType: requirementType,
      submissionType: submissionType,
      search: name || "",
    },
  });
  return {
    data,
    page: page || PAGE,
    totalPages: !!name ? 1 : Math.ceil(paginate.totalCount / LIMIT),
  };
};

// POST
export const UpdateRequirement = async ({ payload, type }) => {
  const res = await Client?.[type](
    `uudesr/design-requisition/requirement-type`,
    payload
  );
  return res.data.data;
};
export const UpdateSubmission = async ({ payload, type }) => {
  const res = await Client?.[type](
    `uudesr/design-requisition/submission-type`,
    payload
  );
  return res.data.data;
};
export const updateRequisitionMapping = async ({ payload, type }) => {
  const res = Client?.[type](
    `uudesr/design-requisition/creative-type`,
    payload
  );
  return res;
};
